/* =========================================================================
   ClueVine — mode registry
   The single place the shell discovers modes. Registration order is preserved,
   so allModes() drives menus in a stable order. Adding a mode is one register
   call (see src/modes/index.ts) — nothing else in the app changes.
   ========================================================================= */

import type { AnyPuzzleMode, ModeId } from './types';

const registry = new Map<ModeId, AnyPuzzleMode>();

export function registerMode(mode: AnyPuzzleMode): void {
  if (registry.has(mode.id)) {
    console.warn(`ClueVine: mode "${mode.id}" is already registered; overwriting.`);
  }
  registry.set(mode.id, mode);
}

export function getMode(id: ModeId): AnyPuzzleMode | undefined {
  return registry.get(id);
}

export function requireMode(id: ModeId): AnyPuzzleMode {
  const mode = registry.get(id);
  if (!mode) throw new Error(`ClueVine: unknown mode "${id}"`);
  return mode;
}

export function allModes(): AnyPuzzleMode[] {
  return [...registry.values()];
}

export function modeIds(): ModeId[] {
  return [...registry.keys()];
}

export function hasMode(id: ModeId): boolean {
  return registry.has(id);
}
